import Checkbox from '@usas/ui-web/components/checkboxes/Checkbox';
import SGColumnHeader from '@usas/ui-web/components/grids/SGColumnHeader';

import useSortableGrid from '@usas/ui-web/utils/UseSortableGrid';
import SGConstants from '@usas/ui-web/utils/SGConstants';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const GridRow = ({ athlete, onEditAthlete, onUpdateIsSyncSelected, onUpdateIsTransferSelected }) => (
  <tr>
    <td><a onClick={() => onEditAthlete(athlete.personId)}>{athlete.preferredName ? athlete.preferredName : athlete.firstName || ''} {athlete.lastName || ''}</a></td>
    <td>{athlete.competitionGenderTypeName || ''}</td>
    <td>{athlete.birthDate || ''}</td>
    <td>{athlete.age || ''}</td>
    <td>{athlete.isInGoodStandingExpirationDate || ''}</td>
    <td>{athlete.orgRoleName || ''}</td>
    <td>{athlete.attachDate || ''}</td>
    <td>{athlete.isTransferPending ? 'Yes' : 'No'}</td>
    <td>
      <Checkbox
        name={`isSyncSelected${athlete.memberId}`}
        checked={athlete.isSyncSelected}
        onChange={() => { onUpdateIsSyncSelected(athlete.memberId) }} />
    </td>
    <td>
      {athlete.isTransferPending === false &&
        <Checkbox
          name={`isTransferSelected${athlete.personOrgRoleDurationId}`}
          checked={athlete.isTransferSelected}
          onChange={() => { onUpdateIsTransferSelected(athlete.personOrgRoleDurationId) }} />
      }
    </td>
  </tr>
);

const ClubAthleteRosterFormGridLarge = ({ formGridState, isLoading, onEditAthlete, onUpdateIsSyncSelected, onUpdateIsTransferSelected }) => {
  const {
    sortableGridState,
    onColumnClicked
  } = useSortableGrid(formGridState);

  return (
    <table className={[global.UsasTable, 'visible-md visible-lg'].join(' ')}>
      <thead>
        <tr>
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={'Name'} columnField={'lastName'}
            sortType={SGConstants.SORT_TYPE_ALPHABETICAL} onColumnClicked={onColumnClicked} />
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={'Comp Category'} columnField={'competitionGenderTypeName'}
            sortType={SGConstants.SORT_TYPE_ALPHABETICAL} onColumnClicked={onColumnClicked} />
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={'Birth Date'} columnField={'birthDate'}
            sortType={SGConstants.SORT_TYPE_DATE} onColumnClicked={onColumnClicked} />
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={'Age'} columnField={'age'}
            sortType={SGConstants.SORT_TYPE_NUMERICAL} onColumnClicked={onColumnClicked} />
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={'Good Standing Until'} columnField={'isInGoodStandingExpirationDate'}
            sortType={SGConstants.SORT_TYPE_DATE} onColumnClicked={onColumnClicked} />
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={'Member Type'} columnField={'orgRoleName'}
            sortType={SGConstants.SORT_TYPE_ALPHABETICAL} onColumnClicked={onColumnClicked} />
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={'Attach Date'} columnField={'attachDate'}
            sortType={SGConstants.SORT_TYPE_DATE} onColumnClicked={onColumnClicked} />
          <th>Transfer Pending</th>
          <th>Sync</th>
          <th>Transfer</th>
        </tr>
      </thead>
      <tbody>
        {isLoading === true
          ? <tr><td colSpan="10">Loading...</td></tr>
          : Array.isArray(sortableGridState.sortedGridData) && sortableGridState.sortedGridData.length > 0
            ? sortableGridState.sortedGridData.map((athlete, i) =>
              <GridRow key={i} athlete={athlete} onEditAthlete={onEditAthlete} onUpdateIsSyncSelected={onUpdateIsSyncSelected} onUpdateIsTransferSelected={onUpdateIsTransferSelected} />)
            : <tr><td colSpan="10">No Athletes</td></tr>
        }
      </tbody>
    </table>
  )
};

export default ClubAthleteRosterFormGridLarge;